"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
const React = __importStar(require("react"));
/**
 * Defining a default context value here, used below when instantiating
 * the context consumer and provider below in order for context to be
 * correctly detected throughout the application.
 */
const defaultContext = {
    pushState: undefined,
    replaceState: undefined,
    pushMessage: (_) => undefined,
    clearMessages: () => undefined,
    loading: false,
    setLoading: (_) => undefined,
};
const ctx = React.createContext(defaultContext);
exports.OperationalContext = ctx.Consumer, exports.Provider = ctx.Provider;
exports.useOperationalContext = () => React.useContext(ctx);
exports.default = exports.OperationalContext;
//# sourceMappingURL=OperationalContext.js.map